import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserDto } from '../../types/user.dto';
import { UserManageAction } from '../../types/user-manage.types';

@Component({
  selector: 'app-user-table',
  templateUrl: './user-table.component.html',
  styleUrl: './user-table.component.scss',
})
export class UserTableComponent {
  @Input({ required: true }) rows: UserDto[] = [];
  @Input() loading = false;

  @Output() action = new EventEmitter<{
    action: UserManageAction;
    row: UserDto;
  }>();

  trackById = (_: number, r: UserDto) => r.id ?? r.uuid;

  onEdit(row: UserDto) {
    this.action.emit({ action: 'edit', row });
  }

  onDelete(row: UserDto) {
    this.action.emit({ action: 'delete', row });
  }

  isActive(row: UserDto) {
    return String(row.status).toUpperCase() === 'ACTIVE';
  }

  statusLabel(active: any): string {
    return active ? 'ใช้งาน' : 'ไม่ได้ใช้งาน';
  }
}
